/*
  Adday cart plan: the Remove button on a plan block (snippets/adday-cart-plan.liquid), in the
  cart drawer and on the cart page.

  One click listener on the document, so it keeps working after the drawer re-renders. Remove
  posts /cart/update.js with every line key of the plan at 0 (one request).
  - Drawer: the response carries the cart-drawer section, so the theme's own
    'update:cart:drawer' event re-renders the drawer (header count, lines, subtotal), and
    wetheme.updateCartCount() updates the header bubble. On the cart page itself the page
    reloads too, so both stay in step.
  - Cart page: the page reloads, like the theme's own Remove link.
  - Cart page quantities: see the end of this file.
  The script is included by the drawer and the cart page, so it guards against running twice.
*/
(() => {
  if (window.AddayCartPlanReady) return;
  window.AddayCartPlanReady = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const onCartPage = () => /\/cart\/?$/.test(window.location.pathname);

  let live;
  const announce = (message) => {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(() => {
      live.textContent = message;
    }, 50);
  };

  const setBusy = (block, button, busy) => {
    const label = button.querySelector('[data-adday-plan-remove-text]');
    if (busy) {
      if (label) {
        button.dataset.label = label.textContent;
        label.textContent = block.dataset.removingText || label.textContent;
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      block.classList.add('is-removing');
    } else {
      if (label && button.dataset.label) label.textContent = button.dataset.label;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      block.classList.remove('is-removing');
    }
  };

  const showError = (block, message) => {
    const el = block.querySelector('[data-adday-plan-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-adday-plan-remove]');
    if (!button || button.disabled) return;
    const block = button.closest('[data-adday-cart-plan]');
    if (!block) return;
    event.preventDefault();

    const keys = (button.dataset.keys || '').split(',').filter(Boolean);
    if (!keys.length) return;
    const inDrawer = block.dataset.context === 'drawer';
    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });
    const body = { updates };
    if (inDrawer) body.sections = 'cart-drawer';

    showError(block, '');
    setBusy(block, button, true);

    try {
      const response = await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const cart = await response.json().catch(() => null);
      if (!response.ok || !cart || cart.status) throw new Error((cart && cart.description) || '');

      if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') {
        window.wetheme.updateCartCount(cart);
      }

      if (inDrawer && !onCartPage()) {
        announce(block.dataset.removedText || '');
        if (window.eventBus) window.eventBus.emit('update:cart:drawer', cart);
        return;
      }
      window.location.reload();
    } catch (error) {
      setBusy(block, button, false);
      showError(block, block.dataset.errorText || error.message);
    }
  });

  /*
    Cart page quantities: the theme's +/- buttons only change the input, and the customer had
    to press "Update cart". Like the drawer, a change now updates the basket on its own: a
    short pause after the last +/- or typed change, then the form posts with "update".
  */
  let qtyTimer;
  const submitCartUpdate = (form) => {
    window.clearTimeout(qtyTimer);
    qtyTimer = window.setTimeout(() => {
      const update = form.querySelector('[name="update"]');
      form.classList.add('is-updating');
      if (update && typeof form.requestSubmit === 'function') form.requestSubmit(update);
      else if (update) update.click();
    }, 600);
  };

  document.addEventListener('click', (event) => {
    const adjust = event.target.closest('form.cart .js-qty__adjust');
    if (adjust) submitCartUpdate(adjust.closest('form.cart'));
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('form.cart .js-qty__num');
    if (input) submitCartUpdate(input.closest('form.cart'));
  });
})();
